export default __webpack_public_path__ + "static/media/planDetails.f58bb5b3.svg";